import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (data) => ({
        url: apiRoutes.auth.login.path,
        method: apiRoutes.auth.login.reqType,
        body: data,
      }),
    }),
    googleLogin: builder.mutation({
      query: (data) => ({
        url: apiRoutes.auth.googleLogin.path,
        method: apiRoutes.auth.googleLogin.reqType,
        body: data,
      }),
    }),
    changeOrg: builder.mutation({
      query: (data) => ({
        url: apiRoutes.auth.changeOrg.path,
        method: apiRoutes.auth.changeOrg.reqType,
        body: data,
      }),
    }),
    acceptInvitation: builder.mutation({
      query: (data) => ({
        url: apiRoutes.auth.validateInvitation.path,
        method: apiRoutes.auth.validateInvitation.reqType,
        body: data,
      }),
    }),
    generateOTP: builder.mutation({
      query: (data) => ({
        url: apiRoutes.auth.generateOtp.path,
        method: apiRoutes.auth.generateOtp.reqType,
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useGoogleLoginMutation,
  useGenerateOTPMutation,
  useChangeOrgMutation,
  useAcceptInvitationMutation,
} = authApiSlice;
